export default "assets/logo-picto-3a9776a4.png";